import type { WidgetPublicReview } from "../contracts/widgets/public/common";
import type { WidgetLocale } from "./localeResolver";

export const formatWidgetRating = (value: number, locale: WidgetLocale): string => {
  const rounded = Math.round(value * 10) / 10;
  const fixed = rounded.toFixed(1);
  return locale === "fr" ? fixed.replace(".", ",") : fixed;
};

export const formatWidgetAuthor = ({
  authorFirstName,
  authorInitial,
}: Pick<WidgetPublicReview, "authorFirstName" | "authorInitial">): string =>
  authorInitial === "" ? authorFirstName : `${authorFirstName} ${authorInitial}.`;

export const formatWidgetInteger = (value: number, locale: WidgetLocale): string =>
  locale === "fr"
    ? String(value).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    : String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
